<template>
    <gat-flex :size="compSize">   
        <b>{{caption}}</b>     
         <!-- <v-list two-line dense>
          <v-list-item v-for="(v, name) in value" :key="name" dense>
            <v-list-item-action>
              <v-icon v-if="expandable(v)" @click="clicked(v,name)">{{getIcon(v)}}</v-icon>
              <v-icon v-else>{{getIcon(v)}}</v-icon>
            </v-list-item-action>
            
            <v-list-item-content>            
              <v-list-item-title>{{name}}</v-list-item-title>
              <v-list-item-sub-title>{{displayValue(v)}}</v-list-item-sub-title>             
            </v-list-item-content>                        
          </v-list-item>          
          </v-list> -->
        <v-treeview class="treeview" :items="items" dense>
            <template  v-slot:prepend="{item}">                
                <v-icon >{{getIcon(item.value)}}</v-icon>               
            </template>
            <template v-slot:label="{item}">
                <span class="blue--text">{{item.name}} </span>:<span>  {{displayValue(item.value)}}</span>
            </template>
        </v-treeview>
    </gat-flex>
</template>

<script>
    import GatFlex from './GatFlex.vue'
    export default {
        name: 'RecordPresenter',
        props: ['value','caption','size'],
        components: {GatFlex},
        data: function() {
            return	{
                lastId : 0,
            }
        },


        created(){
        },

        computed:{
            compSize(){
                if(this.size){
                    return this.size;
                }
                return "xs6";
            },

            nextId(){
                let result = this.lastId;
                if(!result){
                    result = this.startId;
                }
                if(!result){
                    result = 1;
                }
                return result;
            },
            
            
            items(){
               return this.makeNodes(this.value,0);
            }
        },

        watch:{
        },

        methods:{
      
            expandable(v){
                let type = this.getDataType(v);
                if(type=='array' && v.length > 0) return true;
                if(type=='object' && v !== null) return true;
                return false;
            },
            displayValue(v){
                let result = JSON.stringify(v);
                let type = this.getDataType(v);
                if(v===null){
                    result = 'null';
                }
                if(type=='array'){
                    if(v.length != 0){                    
                     result = '[...'+v.length+' items...]';
                    }
                }
                if(type=='object'){
                    let ol=Object.keys(v);
                    if(ol.length != 0){                    
                     result = '{...'+ol.length+' properties...}';
                    }
                }
                return result;
            },
            getDataType(v){
                let result = typeof(v);
                if(result == 'object'){
                    if (Array.isArray(v)){
                        result = 'array';
                    }
                    if(Object.prototype.toString.call(v) === '[object Date]'){
                        result = 'date';
                    }
                    if(v === null){
                        result = 'null'
                    }
                }
                return result;
                
            },
            getIcon(v){
                let result = this.getDataType(v);
                switch (result) {
                    case 'string': return 'text_fields';
                    case 'boolean': return 'toggle_off'; 
                    case 'number': return 'functions';  
                    case 'date': return 'access_time';  
                    case 'array': return 'format_list_numbered'; 
                    case 'object': return 'ballot';
                    case 'null' : return 'code'
                }                       
                return '';
            },         
            makeNodes(obj,level){
                let result = [];               
                if(this.getDataType(obj)=='object'){
                    for (var prop in obj) {
                        let v = obj[prop];
                        this.lastId++;
                        let item = {
                          id:this.lastId,
                          name: prop,
                          value:v,                          
                        }                        
                        if(level < 10 && this.expandable(v)){
                            item.children = this.makeNodes(v,level+1);
                        }     
                        result.push(item);                  
                    }
                }
                if(this.getDataType(obj)=='array'){
                    for (var i = 0; i < obj.length; i++) { 
                        let v = obj[i];
                        this.lastId++;              
                        let item = {
                                    id : this.lastId,
                                    name:'['+i+']',
                                    value:v,
                                    };
                        if(level < 10 && this.expandable(v)){
                            item.children = this.makeNodes(v,level+1);
                        }                                               
                        result.push(item);      
                    }                                                                            
                }
                return result; 
            },
        },
    }
</script>

<style scoped>
    /* .treeview{
        background-color: antiquewhite
    } */
</style>
